import {abbreviateNumber, commaizeNumber} from 'common/util';

const UNIT = {
  DAY: `day`,
  WEEK: `week`,
  MONTH: `month`,
};
const SMALLER_UNIT_MAP = {
  [UNIT.DAY]: `hour`,
  [UNIT.WEEK]: `day`,
  [UNIT.MONTH]: `week`,
};

export function getUnitSmaller(unit): string {
  return SMALLER_UNIT_MAP[unit];
}

export function getAddictionUnit(unit): string {
  // Simply becuase that is how addiction works
  return unit === UNIT.MONTH ? UNIT.DAY : getUnitSmaller(unit);
}

/**
 * Convert a decimal percentage to a formatted string percent to a certain precision
 * @example
 * formatPercent(0.2548, 1);
 * // 25.5%
 * formatPercent(12.342, 0);
 * // 1,234%
 **/

export function formatPercent(value: number, precision = 2): string {
  if (isNaN(value)) {
    value = 0;
  }

  return (
    (value * 100).toLocaleString(undefined, {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    }) + `%`
  );
}

/**
 * format a number to be ready to use in retention table
 * @param value number to be formatted
 * @returns {number}
 */
export function formatNumber(value: number): string {
  return value < 1000000 ? commaizeNumber(value) : abbreviateNumber(value);
}

/**
 * Convert to number order given a number
 * @param number
 */
export function numberToRetentionBucketNumber(number: number): string {
  let bucketNumber;
  switch (number) {
    case 0:
      bucketNumber = `<1`;
      break;
    case 1:
      bucketNumber = `1st`;
      break;
    case 2:
      bucketNumber = `2nd`;
      break;
    case 3:
      bucketNumber = `3rd`;
      break;
    default:
      bucketNumber = number + `th`;
      break;
  }
  return bucketNumber;
}
